/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var InfoCircleIcon20Solid = forwardRef('InfoCircleIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-6.89-3.237a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM8.583 9.01a.875.875 0 1 0 0 1.75h.625v2.474h-.625a.875.875 0 1 0 0 1.75h1.499l1.498.006a.875.875 0 0 0 .007-1.75l-.628-.002V9.885a.875.875 0 0 0-.876-.875h-1.5Z" })));
});
